import fetch from 'cross-fetch'
import { TAX_INPUT_KEYS } from './TaxReducers'

import {
    UPDATE_TAX_INPUT,
    REQUEST_TAX_CALC,
    RECEIVE_TAX_CALC,
    TAX_MORTGAGE_CALC_SHOW,
    TAX_MORTGAGE_CALC_HIDE,
    TAX_MORTGAGE_CALC_SAVE,
    TAX_NEXT_WIZARD_STEP
} from "./TaxActionTypes";

export const updateTaxInput = (key, value) => ({
    type: UPDATE_TAX_INPUT,
    key: key,
    value: value
});

export const mortgageCalcShow = () => ({
    type: TAX_MORTGAGE_CALC_SHOW
});

export const mortgageCalcHide = () => ({
    type: TAX_MORTGAGE_CALC_HIDE
});

export function nextWizardStep() {
    return dispatch => {
        dispatch(fetchTaxCalcIfNeeded())
        dispatch({ type: TAX_NEXT_WIZARD_STEP })
    }
    
};

export const mortgageCalcSave = (propertyFinanceCosts) => ({
    type: TAX_MORTGAGE_CALC_SAVE,
    propertyFinanceCosts: propertyFinanceCosts
})

// We're currently requesting a calculation
function requestTaxCalc() {
    return {
        type: REQUEST_TAX_CALC
    }
}

// Calc come back from server
export const receiveTaxCalc = (json) => ({
    type: RECEIVE_TAX_CALC,
    taxCalculation: json,
    receivedAt: Date.now()
})

// The actual fetching of the calc
function fetchTaxCalc(inputs) {

    // Filter the state for only the values in TAX_INPUT_KEYS
    var values = TAX_INPUT_KEYS.reduce(function (o, k) {
        o[k] = inputs[k];
        return o;
    }, {});

    return dispatch => {
        // TODO:
        var url = 'api/taxprojection/calculate';

        // Tell the app we're starting a request...
        dispatch(requestTaxCalc());

        var postData = {
            nonPropertyEarnings: inputs.nonPropertyEarnings,
            nonPropertyDividendIncome: inputs.nonPropertyDividendIncome,
            propertyIncome: inputs.propertyIncome,
            propertyAllowableExpenses: inputs.propertyAllowableExpenses,
            propertyFinanceCosts: inputs.propertyFinanceCosts
        };

        switch (inputs.goal) {
            case 'retain':
                postData.retainProfit = true;
                postData.projectionYears = inputs.projectionYears;
                break;
            case 'income':
                postData.retainProfit = false;
                postData.projectionYears = 1;
                break;
            case 'nextProperty':
                postData.profitGoal = inputs.profitGoal;
                postData.additionalAnnualInvestment = inputs.additionalAnnualInvestment;
                break;
        }


        return fetch(url, {
            method: 'POST',
            body: JSON.stringify(postData),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
            .then(
                response => response.json(),
                error => console.log('An error occurred.', error)
            )
            .then(json => dispatch(receiveTaxCalc(json)))



    }
}

// Do we need to fetch?
function fetchTaxCalcNeeded(taxCalculation) {
    if (taxCalculation.isFetching) {
        return false;
    }
    if (!taxCalculation.wizardStep >= 4) {
        return false;
    }
    return taxCalculation.isStale;
}


// As it says on the tin
export function fetchTaxCalcIfNeeded() {
    console.log('fetchTaxCalcIfNeeded');
    return (dispatch, getState) => {
        if (fetchTaxCalcNeeded(getState().tax)) {
            return dispatch(fetchTaxCalc(getState().tax));
        } else {
            // Let the calling code know there's nothing to wait for.
            return Promise.resolve()
        }
    }
}


// WEBPACK FOOTER //
// ./src/Features/TaxCalculator/TaxActions.jsx